export default{
    familyHistory : 'سابقه پزشکی خانواده',
    pastMedicalHistory : 'سابقه پزشکی بیمار ',
    historyOfInfertilityInFamily: 'سابقه ناباروری در خانواده',
    historyOfInfertilityInFamilyDescription: 'شرح سابقه ناباروری در خانواده',
    specificDiseaseInFamilyMembers: 'سابقه بیماری خاص در خانواده ',
    specificDiseaseInFamilyMembersDescription: 'شرح سابقه بیماری خاص در خانواده ',
    cancerInFamilyMembers: 'سابقه سرطان در خانواده',
    cancerInFamilyMembersDescription: 'شرح سابقه سرطان در خانواده',
    typeOfDiseaseInFamilyMembers: 'نوع ',
    historyOfCancerInFamilyMembers: 'سابقه سرطان ',
    historyOfDisease: 'سابقه بیماری خاص',
    historyOfCancer: 'سابقه سرطان ',
    typeOfCancer: 'نوع سرطان',
    surgicalHistory: 'سابقه جراحی',
    typeOfSurgery: 'نوع جراحی',
    surgery: 'جراحی',
    sonographyHistory: 'سابقه سونوگرافی',
    sonography: 'سونوگرافی',
    clinicSonography: 'سونوگرافی کلینیک',
    sonographyOutSide: 'سونوگرافی خارج از کلینیک',
    sonographyType: 'نوع سونوگرافی',
    labType: 'نوع آزمایش',
    type: 'نوع ',
    result: 'نتیجه',
    radiologyHistory: 'تاریخچه رادیولوژی',
    papSmear: 'نمونه برداری از سلول های دهانه رحم',
    mri: 'MRI',
    mriList: 'MRI لیست',
    list: 'لیست',
    ctScan: 'سی تی اسکن',
    mammography: 'ماموگرافی',
    ctScanList: 'لیست سی تی اسکن',
    date: 'تاریخ',
    medication: 'سابقه دارویی',
    sfa: 'SFA',
    dfa: 'DFI',
}